import React, { ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useTheme } from './theme-hook';

export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useTheme({ primaryColor: '#2362a2' });

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
